import {Stack, Alert, IconButton, useTheme, Box, Typography } from '@mui/material';
import PictureIcon from '@mui/icons-material/InsertPhoto';
import { useState } from 'react';
import { Delete } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { txt } from '../../services/translation';

export default function Picture({id, label, onChange, value, error, loading}){

    const theme = useTheme()

    const [err, setErr] = useState(error || false)
    const [active, setActive] = useState(false)
    const accept = ['image/png','image/jpeg','image/jpg'];
    const maxSize = 10000000;

    const handleFile = file => {

        setErr(false);
        
        if(!accept.includes(file.type)) {

            setErr(txt('fileFormatNotAccepted', { fileName: file.name }));

            return onChange(null);

        } else if(file.size > maxSize) {

            setErr(txt('fileTooLarge', { fileName: file.name }));
            
            return onChange(null);
        }
            
        file.url = URL.createObjectURL(file);
    
        return onChange(file);
    }
    


    const handleDelete = () => {
        document.getElementById(id || 'picture').value = '';
        return onChange(null);
    }

    const handleChange = e => {
        let files = e.target.files;
        return (files && files.length) ? handleFile(files[0]) : false;
    }

    const handleDrop = e => {
        e.preventDefault();
        let files = e.dataTransfer.files;
        return (files && files.length) ? handleFile(files[0]) : false;
    }

    const handleDrag = e => {
        e.preventDefault();
        setActive(true)
    }

    const handleDragLeave = e => {
        e.preventDefault();
        setActive(false)
    }

    return <Stack spacing={1}>

        {!value &&
            <Stack 
                sx={{
                    height: 100, 
                    border: 'dashed 2px', 
                    borderColor: active ? theme.palette.primary.light : 'lightgrey',
                    borderRadius: '5px'
                }}
                onMouseEnter={() => setActive(true)}
                onMouseLeave={() => setActive(false)}
            >

                <LoadingButton
                    startIcon={<PictureIcon />}
                    onClick={() => document.getElementById(id || 'picture').click()}
                    loading={loading}
                    sx={{height: '100%'}}
                    onDrop={handleDrop}
                    onDragOver={handleDrag}
                    onDragEnter={handleDrag}
                    onDragLeave={handleDragLeave}
                >
                    {label || txt('dropImage')}
                </LoadingButton>

            </Stack>
        }

        {value && <Stack spacing={2}>

            <Typography color='text.secondary'>{label}</Typography>

            <Stack direction='row' alignItems='flex-start'>

                <Box>
                    <img 
                        src={value.url} 
                        alt="img" 
                        width={200}
                        style={{objectFit:'cover'}}
                    />
                </Box>

                <IconButton size='small' onClick={handleDelete}>
                    <Delete />
                </IconButton>


            </Stack>

        </Stack>}

        {err && <Alert severity='error'>{err}</Alert>}

        <input 
            id={id || 'picture'}
            type="file"
            onChange={handleChange}
            style={{display: 'none'}}
            accept={accept.join(',')}
        />

    </Stack>

}

